import axios from '@/utils/request'
import base from '../base'
import qs from 'qs'

export default {
  isAjax() {
    const headers = {
      isAjax: 'true'
    }
    return headers
  },
  header() {
    const headers = {
      'isAjax': 'true',
      'Content-Type': 'application/json'
    }
    return headers
  },
  /*新增分配比列*/
  addProductRatio(data) {
    return axios.post(`${base.url_nm}/rebate/productRatio/addProductRatio`, data, { headers: this.header() })
  },
  /*新增交易产品分配比例*/
  addProductItemRatio(data) {
    return axios.post(`${base.url_nm}/rebate/productItemRatio/addProductItemRatio`, data, { headers: this.header() })
  },
  /*分页查询代理人列表*/
  queryUnionAgentListPage(data) {
    return axios.post(`${base.url_nm}/rebate/agent/queryUnionAgentListPage`, data, { headers: this.header() })
  },
  /*新增代理人*/
  addAgent(data) {
    return axios.post(`${base.url_nm}/rebate/agent/addAgent`, data, { headers: this.header() })
  },
  /*根据id更新代理人*/
  updateAgent(data) {
    return axios.post(`${base.url_nm}/rebate/agent/updateAgent`, data, { headers: this.header() })
  },
  /*根据id删除代理人*/
  deleteAgent(data) {
    return axios.post(`${base.url_nm}/rebate/agent/deleteAgent`, data, { headers: this.header() })
  },
  /*审核代理人*/
  auditAgent(data) {
    return axios.post(`${base.url_nm}/rebate/agent/AuditAgent`, data, { headers: this.header() })
  },
  /*查询代理下拉树形*/
  queryAgentSelectTree() {
    return axios.get(`${base.url_nm}/rebate/agent/queryAgentSelectTree`, { headers: this.isAjax() })
  },
  /*查询代理交易奖励方案列表*/
  queryAssignPlanList(data) {
    return axios.post(`${base.url_nm}/rebate/assignPlan/queryAssignPlanList`, data, { headers: this.header() })
  },
  /*查询代理层级奖励方案列表*/
  queryAssignLevelPlanList(data) {
    return axios.post(`${base.url_nm}/rebate/assignLevelPlan/queryAssignLevelPlanList`, data, { headers: this.header() })
  },
  /*分页查询客户交易明细列表*/
  queryOrderListPage(data) {
    return axios.post(`${base.url_nm}/rebate/order/queryOrderListPage`, data, { headers: this.header() })
  },
  /*分页查询代理收益统计列表*/
  queryAgentProfitListPage(data) {
    return axios.post(`${base.url_nm}/rebate/agentProfit/queryAgentProfitListPage`, data, { headers: this.header() })
  },
  /*分页查询代理收益发放记录列表*/
  queryAgentIncomeListPage(data) {
    return axios.post(`${base.url_nm}/rebate/agentIncome/queryAgentIncomeListPage`, data, { headers: this.header() })
  },
  /*分页查询客户提案列表*/
  queryCustomerItemListPage(data) {
    return axios.post(`${base.url_nm}/rebate/customerItem/queryCustomerItemListPage`, data, { headers: this.header() })
  },
  /*分页查询客户列表*/
  queryCustomerListPage(data) {
    return axios.post(`${base.url_nm}/rebate/customer/queryCustomerListPage`, data, { headers: this.header() })
  },
  /*分页查询客户推荐激活奖励活动列表*/
  queryRecommendActivityListPage(data) {
    return axios.post(`${base.url_nm}/rebate/recommendActivity/queryRecommendActivityListPage`, data, { headers: this.header() })
  },
  /*分页查询用户推荐激活奖励发放记录列表*/
  queryActiveIncomeListPage(data) {
    return axios.post(`${base.url_nm}/rebate/activeIncome/queryActiveIncomeListPage`, data, { headers: this.header() })
  },
  /*分页查询客户推荐交易奖励方案列表*/
  queryRecommendPlanListPage(data) {
    return axios.post(`${base.url_nm}/rebate/recommendPlan/queryRecommendPlanListPage`, data, { headers: this.header() })
  },
  /*分页查询用户推荐交易奖励发放记录列表*/
  queryRecommendIncomeListPage(data) {
    return axios.post(`${base.url_nm}/rebate/recommendIncome/queryRecommendIncomeListPage`, data, { headers: this.header() })
  },
}
